import React from 'react'

import { Field } from 'formik'

import { ZariContext } from '_zari/context'

import { Form, Col, Button } from '_zari/core'

import * as SociosCrud from 'services/socio.service'

const RucFormGroup = ({ iError, iTouched, fIsSubmitting, setFieldValue, vRuc }) => {
  const __zariContext = React.useContext(ZariContext)

  const [opcionesBotonBuscar, setOpcionesBotonBuscar] = React.useState({
    buscando: false,
    texto: 'Buscar'
  })

  const clickBuscarSocioHandler = async () => {
    setOpcionesBotonBuscar({
      buscando: true,
      texto: 'Buscando...'
    })
    await SociosCrud.getSocioViaSunat(vRuc)
      .then(({ data }) => {
        console.log(data)
        setFieldValue('razonSocial', data.razonSocial)
        setFieldValue('direccion', data.direccion)
        setFieldValue('_idDepartamento', data._idDepartamento)
        setFieldValue('_idProvincia', data._idProvincia)
        setFieldValue('_idDistrito', data._idDistrito)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        setOpcionesBotonBuscar({
          buscando: false,
          texto: 'Buscar'
        })
      })
  }

  return (
    <Form.Group>
      <Form.Label text='RUC' htmlFor='select-ruc' sm={4} alignRightAt='sm' />
      <Col sm={8}>
        <Form.InputGroup>
          <Field name='ruc'>
            {({ field }) => (
              <Form.InputText {...field} disabled={fIsSubmitting || opcionesBotonBuscar.buscando} isInvalid={iTouched && iError} id='select-ruc' />
            )}
          </Field>
          <Form.InputGroup.Append>
            <Button disabled={fIsSubmitting || opcionesBotonBuscar.buscando} onClick={clickBuscarSocioHandler}>
              {opcionesBotonBuscar.texto}
            </Button>
          </Form.InputGroup.Append>
        </Form.InputGroup>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(RucFormGroup)
